export default __webpack_public_path__ + "static/pandora-a261d396880ab8f24082d6f033992402.gif";